import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  binTrfIndexResetTimestamp: ['currentPage', 'sorts', 'filters', 'pageSize'],
  binTrfIndexGoToPrint: ['document'],
  binTrfIndexGoToDocument: ['hdrId'],
  binTrfIndexNewDocument: null,
  binTrfIndexGoToAudit: ['hdrId'],
  binTrfIndexFetchBinTrfIndex: ['currentPage', 'sorts', 'filters', 'pageSize'],
  binTrfIndexFetchBinTrfIndexLoading: ['boolean'],
  binTrfIndexFetchBinTrfIndexSuccess: ['documents', 'currentPage', 'lastPage', 'total', 'pageSize'],
  binTrfIndexAddSelectedDocuments: ['selectedDocuments'],
  binTrfIndexRemoveSelectedDocuments: ['selectedDocuments'],
  binTrfIndexSetWorkspaceVisible: ['boolean'],
  binTrfIndexPrintBinTrfIndex: ['hdrIds'],
  binTrfIndexPrintBinTrfIndexLoading: ['boolean']
});

export const BinTrfIndexTypes = Types;
export default Creators;
